import { CUSTOMER_JOURNEY_SERVICES_BOOK } from './../const';

function action(serviceId, token, lang, successCallback, errorCallback) {
  return { type: CUSTOMER_JOURNEY_SERVICES_BOOK, serviceId, token, lang, successCallback, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyServicesBook.js